import React, {
  memo, useEffect, useMemo, useState,
} from 'react'
import { FormattedMessage } from 'react-intl'
import { useSelector } from 'react-redux'
import Button from '@mui/material/Button'
import pickBy from 'lodash/pickBy'
import isEmpty from 'lodash/isEmpty'
import CircularProgress from '@mui/material/CircularProgress'
import Grid from '@mui/material/Grid2'
import useMediaQuery from '@mui/material/useMediaQuery'
import sx from './styles'

const ActionButtons = ({
  handleCleanFilters: handleCleanFiltersProp,
  onSubmit,
  filterResetTitle = 'SEARCH_CLEAN_FILTER',
  variant = 'advanced', // advaced|sort
}) => {
  const {
    filters, totalVehicles, isSeeVehiclesBtnDisabled, loading,
  } = useSelector((s) => s.search)

  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'))

  const activeButtons = useMemo(() => Boolean(
    filters?.maker
    || filters?.model
    || filters?.year
    || filters?.transmission,
  ), [
    filters,
    filters?.maker,
    filters?.model,
    filters?.year,
    filters?.transmission,
  ])

  const [totalV, setTotalV] = useState(totalVehicles || 0)
  // const [disabledButton, setDisabledButton] = useState(false)

  const handleCleanFilters = () => {
    handleCleanFiltersProp()
    // setDisabledButton(true)
  }

  useEffect(() => {
    setTotalV(totalVehicles)
  }, [totalVehicles])

  const filtersWithoutBodyType = pickBy({
    ...filters,
    body: null,
  })

  const scrollToTop = () => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
  }

  const handleSubmit = () => {
    if (variant === 'advanced') {
      onSubmit(filters, true)
    } else {
      onSubmit(filters)
    }
    scrollToTop()
  }

  useEffect(() => {
    setTotalV((
      isEmpty(pickBy(filtersWithoutBodyType)) && isSeeVehiclesBtnDisabled
    )
      ? 0
      : totalVehicles)
  }, [filters, totalVehicles, isSeeVehiclesBtnDisabled])

  // useEffect(() => {
  //   // Verifica si window y dataLayer existen antes de enviar los datos
  //   if (typeof window !== 'undefined') {
  //     window.dataLayer = window.dataLayer || []
  //     window.dataLayer.push({
  //       event: 'VerAutos', // Nombre del evento
  //       filtros_seleccionados: JSON.stringify(filters || {}),
  //       total_autos: totalV, // Número de autos que el usuario está viendo
  //     })
  //   }
  // }, [totalV])

  return (
    <Grid
      size={12}
      sx={sx.actions}
    >
      <Button
        variant="grey"
        onClick={handleCleanFilters}
        sx={sx.defaultButton}
        disabled={(!activeButtons && isMobile && variant === 'advaced')}
      >
        <FormattedMessage
          key={filterResetTitle}
          id={filterResetTitle}
        />
      </Button>
      <Button
        variant="contained"
        color="primary"
        sx={sx.primaryButton}
        onClick={handleSubmit}
        disabled={(!activeButtons && isMobile && variant === 'advaced')}
        id="btn_ver_autos"
      >
        {loading && variant !== 'sort' ? (
          <FormattedMessage
            id={isMobile ? 'SEARCH_SEE_ALL_VEHICLES' : 'SEARCH_SEE_ALL_VEHICLES'}
            values={{
              vehicles: (
                <CircularProgress
                  size={15}
                  sx={sx.progress}
                  thickness={5}
                />),
            }}
          />
        ) : (
          variant === 'sort' ? (
            <FormattedMessage id="SEARCH_SORT_BY_MOBILE" />
          ) : (
            <FormattedMessage
              id={isMobile ? 'SEARCH_SEE_ALL_VEHICLES' : 'SEARCH_SEE_ALL_VEHICLES'}
              values={{
                vehicles: totalV,
              }}
            />

          )

        )}

      </Button>
    </Grid>
  )
}

export default memo(ActionButtons)
